<template>
  <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5.62804 16.9138H5.12827C4.59339 16.7738 4.14869 16.4869 3.77421 16.0945C3.07825 15.3652 2.51721 14.5432 2.05737 13.6529C1.50734 12.588 1.16521 11.4595 1.00757 10.2762C0.893988 9.42576 0.885728 8.57668 1.09913 7.73979C1.42956 6.44351 2.1028 5.38133 3.31987 4.71222C4.10739 4.27922 4.95067 4.0952 5.838 4.31102C6.33571 4.43212 6.82033 4.61615 7.29945 4.80017C7.74002 4.96931 8.16338 5.00178 8.60533 4.80896C8.89376 4.68313 9.19665 4.59044 9.49335 4.48422C10.9231 3.97207 12.2744 4.12632 13.5376 4.96119C13.8887 5.19325 14.1689 5.50108 14.3988 5.86709C13.1157 6.66813 12.4713 7.78309 12.5808 9.2918C12.6902 10.8032 13.5073 11.816 14.8573 12.452C14.8421 12.5061 14.8359 12.5379 14.8249 12.5683C14.3706 13.8653 13.6443 15.0073 12.7439 16.0445C12.1278 16.7535 11.3534 17.062 10.4068 16.809C10.0709 16.719 9.74255 16.5972 9.41694 16.4734C8.72648 16.2102 8.02708 16.1507 7.31597 16.3712C6.75218 16.5458 6.19115 16.7325 5.62942 16.9132L5.62804 16.9138Z"
        :fill="color"/>
    <path
        d="M11.2915 0.143499C11.3487 0.778782 11.2578 1.37753 10.9769 1.93704C10.5742 2.73875 10.0097 3.39771 9.17059 3.79147C8.79129 3.9694 8.32938 4.03909 7.8895 3.99443C7.66026 2.23472 9.22566 0.322109 11.2915 0.142822V0.143499Z"
        :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: "AppleWhiteIcon",
  props: {
    color: {
      type: String,
      required: false,
      default: "#6D7492"
    }
  }
};
</script>
